import { Form, Input, Menu, Modal, notification } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useCallback, useState } from "react";
import Requestor from "../../requestor";

type IProps = { logout: () => void };

const ChangePwdMenuItem = (props: IProps) => {
	const [visible, setVisible] = useState<boolean>(false);
	const [form] = Form.useForm();
	// let Requestor = useSelector(getRequestor);

	// 修改密码
	const change = useCallback(
		async ({ oldPassword, newPassword, confirmPassword }: { oldPassword: string; newPassword: string; confirmPassword: string }) => {
			try {
				/* const timestamp = Math.ceil(new Date().getTime() / 1000);
				const raw = `${timestamp}.${oldPassword}.${newPassword}.${confirmPassword}`;
				const payload = RSA.encrypt(raw);
				if (payload === false) {
					notification.error({
						message: "系统错误，请联系管理员",
					});

					return;
				} */

				let res = await Requestor.changePwd({ oldPassword, newPassword, confirmPassword});
				if (res.error !== "") {
					throw new Error(res.error);
				}
				Modal.confirm({
					title: "修改密码成功",
					content: "密码已经修改，请重新登录",
					okText: "确认",
					onOk: () => {
						props.logout();
					},
					onCancel: () => {
						props.logout();
					},
					okType: "primary",
				});
				setVisible(false);
			} catch (e: any) {
				notification.error({
					message: "修改客户信息失败",
					description: `错误信息： ${e.message}`,
				});
			}
		},
		[props]
	);

	//必填项rule
	const getRule = useCallback((message: string) => {
		return [
			{
				required: true,
				message: message,
			},
		];
	}, []);
	return (
		<>
			<Menu.Item key="cp" icon={<LockOutlined />} onClick={setVisible.bind(this, true)}>
				<span>修改密码</span>
			</Menu.Item>
			<Modal title="修改密码" open={visible} maskClosable={false} destroyOnClose={true} onOk={form.submit} onCancel={setVisible.bind(this, false)}>
				<Form form={form} preserve={false} layout="vertical" onFinish={change}>
					<Form.Item name="oldPassword" label="原始密码" rules={getRule("请输入原始密码")}>
						<Input.Password></Input.Password>
					</Form.Item>
					<Form.Item name="newPassword" label="新密码" rules={getRule("请输入新密码")}>
						<Input.Password></Input.Password>
					</Form.Item>
					<Form.Item
						name="confirmPassword"
						label="确认密码"
						rules={[
							getRule("请再次输入密码")[0],
							({ getFieldValue }) => ({
								validator(_, value) {
									if (value && value !== getFieldValue("newPassword")) {
										return Promise.reject(new Error("两次输入密码不一致"));
									}
									return Promise.resolve();
								},
							}),
						]}
					>
						<Input.Password></Input.Password>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
};
export default ChangePwdMenuItem;
